var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "h-auto w-full",
      attrs: {
        "data-comp": "CatsafeLogoSvg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 149 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M122.493 81.8369C122.493 81.5289 122.482 81.2209 122.493 80.9129C122.521 80.3709 122.72 80.1349 123.249 80.0479C123.684 79.9769 124.122 79.9699 124.551 79.9199C130.536 79.2389 135.235 76.3999 138.631 71.4399C140.396 68.8589 141.396 65.9699 141.727 62.8589C141.775 62.3609 141.831 61.8699 141.931 61.3849C142.024 60.9099 142.292 60.6989 142.779 60.6859C143.391 60.6709 144.012 60.6709 144.628 60.6869C145.122 60.7029 145.39 60.9579 145.383 61.5209C145.383 62.2409 145.334 62.9639 145.244 63.6799C144.848 66.8689 143.839 69.8499 142.148 72.5819C138.854 77.9259 134.162 81.4099 128.073 82.9359C126.684 83.2859 125.226 83.3799 123.806 83.5819C123.733 83.5959 123.66 83.5949 123.587 83.5949C122.723 83.6039 122.493 83.3739 122.493 82.5109C122.493 82.2849 122.493 82.0579 122.493 81.8369Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M122.493 73.169C122.493 72.898 122.482 72.628 122.493 72.354C122.521 71.701 122.761 71.449 123.423 71.377C124.502 71.256 125.57 71.058 126.583 70.63C129.99 69.187 132.116 66.658 132.961 63.063C133.08 62.57 133.125 62.062 133.187 61.555C133.248 61.026 133.477 60.743 134.006 60.71C134.643 60.671 135.283 60.671 135.927 60.696C136.365 60.712 136.672 60.969 136.683 61.431C136.7 62.086 136.679 62.755 136.557 63.399C135.916 66.765 134.274 69.559 131.64 71.747C129.801 73.277 127.693 74.279 125.327 74.712C124.67 74.837 123.995 74.905 123.327 74.95C122.801 74.989 122.589 74.787 122.536 74.267C122.494 73.903 122.494 73.536 122.48 73.169C122.483 73.17 122.488 73.169 122.493 73.169Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M129.217 55.4694C129.168 55.2794 128.996 55.1444 128.799 55.1444L120.248 55.1424L126.269 45.6524C126.795 44.8214 127.316 43.9864 127.837 43.1514L128.57 41.9774C128.653 41.8444 128.658 41.6764 128.582 41.5394C128.506 41.4024 128.362 41.3174 128.205 41.3174H117.169C117.001 41.3174 116.848 41.4154 116.777 41.5684L116.72 41.6934C116.682 41.7784 116.644 41.8624 116.603 41.9444L106.612 61.9194C106.538 62.0454 106.415 62.2564 106.457 62.5494C106.487 62.7624 106.669 62.9204 106.884 62.9204H114.318L107.264 79.6594C107.202 79.8064 107.137 79.9534 107.072 80.0984C106.885 80.5154 106.692 80.9474 106.573 81.4194C106.528 81.5984 106.601 81.7864 106.757 81.8864C106.828 81.9334 106.91 81.9564 106.991 81.9564C107.086 81.9564 107.18 81.9254 107.259 81.8624C107.682 81.5284 108.002 81.1224 108.313 80.7304C108.421 80.5924 108.529 80.4564 108.642 80.3234C115.426 72.2774 122.204 64.2254 129 56.1544C129.077 56.0794 129.314 55.8504 129.217 55.4694Z",
          fill: "#EF7911",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M66.1572 24.534C65.6572 24.144 65.0602 23.867 64.3682 23.7C63.6772 23.535 62.9132 23.449 62.0732 23.449C60.1822 23.449 58.7622 23.808 57.8122 24.521C56.8702 25.234 56.3932 26.517 56.3932 28.369V30.708C56.3932 31.708 56.5412 32.543 56.8332 33.196C57.1232 33.854 57.6112 34.519 58.3062 35.187L62.1822 39.069C62.5652 39.447 62.8342 39.881 62.9892 40.375C63.1442 40.863 63.2212 41.33 63.2212 41.778V43.849C63.2212 44.521 63.1052 44.993 62.8782 45.27C62.6512 45.551 62.3122 45.691 61.8542 45.691C60.9442 45.691 60.4912 45.189 60.4912 44.184V39.768H56.2052V43.682C56.2052 44.641 56.3412 45.441 56.6142 46.072C56.8852 46.709 57.2732 47.224 57.7762 47.614C58.2732 48.004 58.8712 48.281 59.5612 48.447C60.2542 48.613 61.0162 48.697 61.8542 48.697C63.7292 48.697 65.1592 48.357 66.1412 47.676C67.1252 46.999 67.6152 45.812 67.6152 44.116V41.174C67.6152 40.103 67.4692 39.189 67.1682 38.432C66.8682 37.673 66.4202 37.005 65.8232 36.423L61.7152 32.379C61.5162 32.177 61.3542 31.994 61.2282 31.827C61.0952 31.657 60.9992 31.473 60.9262 31.276C60.8552 31.075 60.8052 30.85 60.7782 30.604C60.7492 30.362 60.7372 30.07 60.7372 29.733V28.097C60.7372 27.002 61.1872 26.455 62.0892 26.455C62.9912 26.455 63.4402 26.958 63.4402 27.961V31.575H67.7282V28.463C67.7282 27.504 67.5932 26.707 67.3162 26.074C67.0412 25.441 66.6572 24.926 66.1572 24.534Z",
          fill: "#EF7911",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M79.7766 24.6872C79.2376 24.2832 78.6066 23.9782 77.8776 23.7682C77.1446 23.5572 76.3586 23.4492 75.5216 23.4492C74.6646 23.4492 73.8676 23.5572 73.1266 23.7682C72.3886 23.9782 71.7506 24.2832 71.2126 24.6872C70.6736 25.0852 70.2486 25.5802 69.9376 26.1572C69.6306 26.7402 69.4736 27.3862 69.4736 28.0992V47.9652H74.1456V38.5322H76.8736V47.9652H81.5166V28.0992C81.5166 27.3862 81.3596 26.7412 81.0496 26.1572C80.7416 25.5802 80.3146 25.0862 79.7766 24.6872ZM76.8716 35.4562H74.1436V27.9702C74.1436 26.9652 74.5956 26.4572 75.5056 26.4572C76.4156 26.4572 76.8706 26.9642 76.8706 27.9702V35.4562H76.8716Z",
          fill: "#EF7911",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M93.4448 27.3952V24.1182H83.4248V47.9652H88.0658V36.7922H93.2798V33.6502H88.0658V27.3952H93.4448Z",
          fill: "#EF7911",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M105.102 27.395V24.118H94.8662V47.965H105.131V44.688H99.5072V36.528H104.942V33.381H99.5072V27.395H105.102Z",
          fill: "#EF7911",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M45.4824 32.1918L48.2334 33.2458L54.0354 20.4458L50.2704 19.0918L45.4824 32.1918Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M15.6281 33.305L17.7181 31.247H11.4501L9.28015 33.542H13.3001L10.7681 36.017H17.9651V33.305H15.6281Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M23.6532 36.0167L26.2411 33.3047H23.4941V36.0167H23.6532Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M31.9727 22.8043H36.4716V47.4093H41.9386V22.8043H45.3156V19.2803H31.9727V22.8043Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M23.4938 36.0166H17.9648V47.2476H23.4938V36.0166Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M24.8758 18.7275C18.2068 18.8835 17.9648 24.5065 17.9648 24.5065V33.3035H23.4938V23.7975C23.6928 21.9325 25.0428 22.2905 25.0428 22.2905C26.2428 22.1305 26.4048 23.7975 26.4048 23.7975V47.3275H31.8658V24.5865C30.9848 18.8045 24.8758 18.7275 24.8758 18.7275Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M23.4938 33.3047H17.9648V36.0167H23.4938V33.3047Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.57615 43.522C9.57615 43.522 9.68115 44.689 7.96615 44.689C7.96615 44.689 6.57016 44.37 6.57016 43.522V23.347C6.57016 23.347 6.89415 22.503 7.96615 22.503C7.96615 22.503 9.36217 22.606 9.36217 23.455V29.158H15.0402V25.041C15.0402 25.041 13.9652 19.016 7.96716 18.908C7.96716 18.908 0.896158 19.648 1.00116 25.88C1.00716 26.266 1.00116 40.99 1.00116 40.99C1.00116 40.99 0.896166 47.859 7.86017 47.962C8.20017 47.966 13.5382 48.28 15.0402 42.787V37.61H9.57716V43.522H9.57615Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M139.55 16.747C139.174 13.258 136.764 10.955 133.273 10.729C125.924 10.25 119.258 7.757 113.306 3.193C112.145 2.304 110.95 1.386 109.174 1H107.528L107.136 1.09C106.845 1.243 106.541 1.372 106.238 1.506C105.514 1.825 104.764 2.152 104.115 2.677C97.9592 7.573 90.9072 10.291 83.1512 10.747C80.0542 10.93 77.5482 13.285 77.1932 16.342C77.0542 17.549 76.9552 18.75 76.8822 19.951L76.8252 20.867H82.9292L82.9832 20.064C83.0492 19.091 83.1402 18.118 83.2562 17.15C83.2882 16.912 83.3172 16.867 83.5932 16.845L84.1172 16.809C84.6402 16.778 85.1592 16.741 85.6772 16.683C93.8782 15.755 101.257 12.715 107.615 7.645C107.876 7.437 108.276 7.121 108.304 7.081C108.426 7.121 108.804 7.422 109.051 7.618C115.973 13.137 124.031 16.241 133 16.841C133.344 16.863 133.42 16.923 133.42 16.923C133.42 16.923 133.484 16.998 133.525 17.334C133.542 17.46 133.551 17.589 133.558 17.715L133.581 18.06C134.359 26.189 133.52 33.941 131.099 41.106C130.038 44.245 128.689 47.176 127.056 49.896L133.974 49.974C136.66 44.662 138.462 38.711 139.37 32.139C140.058 27.166 140.119 21.992 139.55 16.747Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M95.4919 57.4886C93.7899 55.7136 92.182 53.7056 90.713 51.5196L90.455 51.1406H83.3359L84.1069 52.4396C87.9239 58.8696 92.857 64.1926 98.774 68.2536C100.831 69.6696 102.941 71.1186 105.407 72.1316L107.776 66.5136C103.197 64.2466 99.0649 61.2146 95.4919 57.4886Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M145.412 12.2402C147.266 12.2402 148.705 13.6782 148.705 15.4742C148.705 17.3072 147.267 18.7272 145.393 18.7272C143.539 18.7272 142.061 17.3072 142.061 15.4742C142.061 13.6782 143.54 12.2402 145.393 12.2402H145.412ZM145.373 12.8902C143.954 12.8902 142.888 14.0542 142.888 15.4742C142.888 16.9132 143.954 18.0572 145.412 18.0572C146.833 18.0772 147.876 16.9132 147.876 15.4742C147.876 14.0542 146.833 12.8902 145.393 12.8902H145.373ZM144.88 17.1502H144.13V13.9352C144.426 13.8752 144.84 13.8172 145.373 13.8172C145.984 13.8172 146.26 13.9172 146.497 14.0742C146.674 14.2122 146.811 14.4692 146.811 14.7642C146.811 15.1382 146.535 15.4142 146.142 15.5332V15.5722C146.456 15.6722 146.634 15.9262 146.733 16.3622C146.833 16.8552 146.89 17.0522 146.97 17.1502H146.16C146.062 17.0312 146.003 16.7552 145.903 16.3802C145.845 16.0262 145.648 15.8682 145.234 15.8682H144.879V17.1502H144.88ZM144.9 15.3362H145.254C145.669 15.3362 146.004 15.1982 146.004 14.8622C146.004 14.5662 145.787 14.3692 145.314 14.3692C145.117 14.3692 144.979 14.3902 144.9 14.4092V15.3362Z",
          fill: _vm.fillColor,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }